import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FavoritesPageLinkComponent } from '../../../$lazy-content/components/favorites/favorites-page-link/favorites-page-link.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ProductPageService } from '../../../page/product-page/product-page.service';

@Component({
    selector: 'ncg-send-offer-button',
    standalone: true,
    template: `
        <button
            *ngIf="productPageService.productPageData$ | async as productPageData"
            type="button"
            [ngClass]="buttonClass"
            (click)="productPageService.openSendOffer()"
        >
            {{ productPageData.sendOfferButtonText || 'product_details.send_offer_button' | translate }}
        </button>
    `,
    imports: [CommonModule, TranslateModule, FavoritesPageLinkComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SendOfferButtonComponent {
    @Input()
    public buttonClass?: string;
    constructor(public readonly productPageService: ProductPageService) {}
}
